// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-role-modal {
  background-color: #FFFDFC;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 2rem;
}

.change-role-modal h2 {
  margin-bottom: 2rem;
}

.change-role-modal h3{
  font-size: 1.8rem;
  font-weight: 900;
  margin-bottom: 1rem;
}

.lots-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2rem;
}

.switch-label {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  font-weight: 600;
  gap: 2rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #E5E7EB;
  transition: .4s;
  border-radius: 9999px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #DA7027;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

.lot-item,
.lot-item-all {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 0;
}

.lot-item-all {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.5rem;
}

.lot-item-all .switch-label {
  width: auto;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.lot-item-all .switch-label span {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2C3948;
}
.divider {
  height: 1px;
  background-color: #E5E7EB;
  margin: 1.6rem 0;
  width: 100%;
}

.section-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #2C3948;
  margin-bottom: 0.7rem;
  border-bottom: 2px solid #222;
  padding-bottom: 0.3rem;
}

.lot-item.lot-item-title{
  display: block;
}

.info-message {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #F3F4F6;
  border-left: 4px solid #DA7027;
  border-radius: 4px;
}

.info-message p {
  margin: 0;
  color: #4B5563;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/composants/ChangeRole/ChangeRole.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".change-role-modal {\n  background-color: #FFFDFC;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-top: 2rem;\n}\n\n.change-role-modal h2 {\n  margin-bottom: 2rem;\n}\n\n.change-role-modal h3{\n  font-size: 1.8rem;\n  font-weight: 900;\n  margin-bottom: 1rem;\n}\n\n.lots-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  margin-bottom: 2rem;\n}\n\n.switch-label {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  font-weight: 600;\n  gap: 2rem;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 42px;\n  height: 22px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #E5E7EB;\n  transition: .4s;\n  border-radius: 9999px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #DA7027;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.lot-item,\n.lot-item-all {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.2rem 0;\n}\n\n.lot-item-all {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.lot-item-all .switch-label {\n  width: auto;\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.lot-item-all .switch-label span {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #2C3948;\n}\n.divider {\n  height: 1px;\n  background-color: #E5E7EB;\n  margin: 1.6rem 0;\n  width: 100%;\n}\n\n.section-title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #2C3948;\n  margin-bottom: 0.7rem;\n  border-bottom: 2px solid #222;\n  padding-bottom: 0.3rem;\n}\n\n.lot-item.lot-item-title{\n  display: block;\n}\n\n.info-message {\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background-color: #F3F4F6;\n  border-left: 4px solid #DA7027;\n  border-radius: 4px;\n}\n\n.info-message p {\n  margin: 0;\n  color: #4B5563;\n  font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
